/**
 * El sonido de los reels de «Nuestra comunidad».
 *
 * Horizon pinta el video sin controles nativos (`disable_controls`): en
 * bucle, sin sonido -que es lo unico que el navegador deja arrancar al
 * pulsar- y con un boton a toda la baldosa que alterna reproducir/pausar.
 * Este script anade lo que Fran pidio el 17/09: un boton de sonido que
 * aparece al darle al play y que lo pone y lo quita. Por delegacion: los
 * bloques se pintan tantas veces como reels hay y el script se carga una vez.
 *
 * CON GUARDA, y no es un detalle (Fran, 22/09/2026: «el boton de unmute no
 * funciona»). El bloque emite su `<script src>` una vez POR REEL: el
 * navegador descarga el fichero una sola vez, pero EJECUTA cada etiqueta, asi
 * que con los cuatro reels de «Nuestra comunidad» el oyente quedaba
 * registrado cuatro veces y cada clic invertia `muted` cuatro veces -un
 * numero par-, o sea que no pasaba nada. Medido: cuatro `<script>` y el
 * `muted` igual antes y despues del clic. Es la misma guarda que llevan
 * `natnatura-tramos`, `natnatura-suscripcion` y `natnatura-hitos`.
 */
(() => {
  if (window.__nnReel) return;
  window.__nnReel = true;

  const ensena = (reel) => {
    const boton = reel.querySelector('[data-nn-reel-sonido]');
    if (boton) boton.hidden = false;
  };

  // En captura: el clic no llegaba al documento (algo entre medias lo para
  // y, de paso, pausaba el video), asi que se atiende antes que nadie.
  document.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) return;

    const sonido = e.target.closest('[data-nn-reel-sonido]');
    if (sonido) {
      e.preventDefault();
      e.stopPropagation();
      const video = sonido.closest('.nn-reel')?.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      sonido.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      return;
    }

    const play = e.target.closest('.nn-reel .deferred-media__poster-button');
    if (play) {
      const reel = play.closest('.nn-reel');
      // El video se clona del <template> al pulsar; el boton sale un
      // instante despues, cuando ya hay <video> al que hablarle.
      window.setTimeout(() => {
        if (reel && reel.querySelector('video')) ensena(reel);
      }, 50);
    }
  }, true);

  // Si se pausa un reel y se arranca otro, el sonido no se solapa: al
  // arrancar uno, los demas callan.
  document.addEventListener('play', (e) => {
    const v = e.target;
    if (!(v instanceof HTMLVideoElement) || !v.closest('.nn-reel')) return;
    document.querySelectorAll('.nn-reel video').forEach((otro) => {
      if (otro !== v && !otro.paused) otro.pause();
    });
  }, true);
})();
